<template>
  <section
    class="content-current"
    style="margin-top: 60px; margin-bottom: 60px"
  >
    <SKLPrintTicket v-if="isLoading" />
    <div class="card-header mt-4">
      <h4 class="box-title">
        <i class="fa fa-info-circle fa-fw"></i><label>اطلاعات واچر </label>
      </h4>
    </div>
    <div
      v-if="!isLoading"
      class="content-current"
      style="margin-top: 20px"
      id="voucherdata"
      ref="voucherdata"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          border: 1px solid;
          padding: 20px;
        "
      >
        <!-- <div style="width: 15%; float: right !important">
          <img
            width="100"
            height="70"
            :src="'data:image/jpeg;base64,' + logo"
          />
        </div> -->
        <div style="width: 85%; display: flex; justify-content: center">
          <barcode v-bind:value="voucherNumber" format="CODE39" height="40">
          </barcode>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          border: 1px solid;
          padding: 20px;
        "
      >
        <div style="width: 15%">
          <img
            src="/img/pdk_logo.png"
            width="300px"
            height="47px"
            alt="City tours"
            data-retina="true"
            @click.prevent="gotoHome"
            style="cursor: pointer"
          />
        </div>
        <div style="width: 85%; display: grid; text-align: left">
          <label>
            تاریخ رزرو:
            <!-- <span v-if="providerId === '2'">
              {{ inDate | persianDate("YYYY/MM/DD") }}</span
            > -->
            <span> {{ inDate | persianDate("jYYYY/jMM/jDD") }}</span>
          </label>
          <label>
            شماره رزرو: <span> {{ reserveNumber }}</span></label
          >
          <label>
            {{ $t("FastTrack.TotalPrice") }} :
            {{ reservedData.totalAmount | numFormat }}
            {{ $t("Rial") }}
          </label>
        </div>
      </div>
      <div class="pass">اطلاعات رزرو</div>
      <div
        style="
          direction: rtl;
          border: 1px solid black;
          padding: 6px;
          text-align: right;
        "
      >
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 30%"
            ><span style="font-size: 8pt !important">تامین کننده:</span>
            {{ providerTitle }}</label
          >

          <label style="margin-right: 1%; width: 30%"
            ><span>فروشنده :</span>{{ sellerName }}<span></span>
          </label>
          <label style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
            ><span>خدمات :</span>{{ serviceName }} ({{
              scheduleDescription
            }})<span></span>
          </label>
        </div>
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 30%"
            ><span>تاریخ ورود :</span>
            <span v-if="providerId === 2">
              {{ arrivalDate | persianDate("YYYY/MM/DD") }}
            </span>
            <span v-else>
              {{ arrivalDate | persianDate("jYYYY/jMM/jDD") }}
            </span>
          </label>

          <label style="margin-right: 1%; width: 30%"
            ><span>تعداد مهمان:</span>{{ adultCount }} بزرگسال -
            {{ childCount }} کودک -<span>
              <span> {{ infantCount }} نوزاد </span>
            </span>
          </label>
          <label style="margin-right: 1%; width: 30%"
            ><span>مجموع رزروشده : </span>{{ guestCount }} نفر<span></span>
          </label>
        </div>
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 30%"
            ><span>برنامه زمانی:</span> {{ scheduleTime }}</label
          >

          <label style="margin-right: 1%; width: 30%"
            ><span>شماره واچر:</span>{{ voucherNumber }}<span></span>
          </label>
          <label style="margin-right: 1%; width: 30%" v-if="providerId === 2">
            <span>شماره پرواز:</span>{{ flightNumber }}<span></span
          ></label>
        </div>
        <br />
        <template v-if="addOnOptionList.length > 0">
          <hr />
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
          >
            <label style="margin-right: 1%; width: 30%"
              ><span style="font-size: 10pt !important"> سایر خدمات</span>
            </label>

            <label style="margin-right: 1%; width: 30%"> </label>
            <label
              style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
            >
            </label>
          </div>

          <div
            v-for="addon in addOnOptionList"
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
          >
            <label style="margin-right: 1%; width: 30%"
              ><span style="font-size: 8pt !important"> نوع خدمات:</span>
              {{ addon.addOnOption.name }}</label
            >

            <label style="margin-right: 1%; width: 30%"
              ><span>تعداد :</span> {{ addon.quantity }}<span></span>
            </label>
            <label
              style="margin-right: 1%; width: 30%; font-size: 8pt !importan"
            >
            </label>
          </div>
        </template>
      </div>

      <div class="pass">مشخصات مشتری</div>
      <div
        style="
          direction: rtl;
          border: 1px solid black;
          padding: 6px;
          text-align: right;
        "
      >
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 30%"
            ><span>نام:</span>
            {{ firstName }}
          </label>

          <label style="margin-right: 1%; width: 30%"
            ><span>نام خانوادگی :</span>{{ lastName }}<span></span>
          </label>
          <label style="margin-right: 1%; width: 30%"
            ><span> پست الکترونیک: </span>{{ email }}<span></span>
          </label>
        </div>
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 30%"
            ><span> شماره همراه:</span> {{ mobileNumber }}</label
          >

          <label v-if="providerId === 2" style="margin-right: 1%; width: 30%"
            ><span>پاسپورت :</span>{{ nationalCode }}<span></span>
          </label>

          <label v-else style="margin-right: 1%; width: 30%"
            ><span>کد ملی:</span>{{ nationalCode }}<span></span>
          </label>

          <label style="margin-right: 1%; width: 30%"> </label>
        </div>
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <label style="margin-right: 1%; width: 90%"
            ><span> توضیحات:</span> {{ customerRequest }}</label
          >
        </div>

        <template v-if="providerId === 2 && bookingGuests.length">
          <hr />
          <div
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
          >
            <label style="margin-right: 1%; width: 90%"
              ><span> همراهان </span>
            </label>
          </div>
          <div
            v-for="guest in bookingGuests"
            style="
              margin-bottom: 50px;
              margin-right: 1%;
              display: contents;
              font-size: 10pt;
            "
          >
            <label style="margin-right: 1%; width: 30%"
              ><span v-if="guest.ageCategoryId === 3"> نام بزرگسال :</span>
              <span v-if="guest.ageCategoryId === 2"> نام کودک :</span>
              <span v-if="guest.ageCategoryId === 1"> نام نوزاد :</span>
              {{ guest.firstName }}</label
            >
            <label style="margin-right: 1%; width: 30%">
              <span v-if="guest.ageCategoryId === 3">
                نام خانوادگی بزرگسال :</span
              >
              <span v-if="guest.ageCategoryId === 2"> نام خانوادگی کودک :</span>
              <span v-if="guest.ageCategoryId === 1">
                نام خانوادگی نوزاد :</span
              >
              {{ guest.lastName }}
            </label>
            <label style="margin-right: 1%; width: 30%"
              ><span v-if="guest.ageCategoryId === 3"> پاسپورت بزرگسال :</span>
              <span v-if="guest.ageCategoryId === 2"> پاسپورت کودک :</span>
              <span v-if="guest.ageCategoryId === 1"> پاسپورت نوزاد :</span>
              {{ guest.nationalCode }}</label
            >
          </div>
        </template>

        <br />
      </div>

      <div class="pass">قوانین</div>
      <div
        style="
          direction: rtl;
          border: 1px solid black;
          padding: 6px;
          text-align: right;
        "
      >
        <div
          style="
            margin-bottom: 50px;
            margin-right: 1%;
            display: contents;
            font-size: 10pt;
          "
          id="time"
        >
          <p v-html="rules" ref="document"></p>
        </div>

        <br />
      </div>
    </div>
    <hr />
    <div class="btn-align">
      <button type="submit" class="btn-profile" @click="print">چاپ واچر</button>
      <button type="submit" class="btn-profile" @click="backToSearch">
        جستجوی مجدد
      </button>
    </div>
  </section>
</template>
<script>
import store from "../../views/tourism/store/index";
import VueBarcode from "vue-barcode";
import SKLPrintTicket from "./SKLPrintTicket";

export default {
  store,
  components: { barcode: VueBarcode, SKLPrintTicket },

  data() {
    return {
      customerInfo: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        emailAddress: "",
        isCustomerReserver: true,
        gender: "",
        birthDate: "",
        nationalCode: "",
      },
      providerId: 0,
      providerName: "fasttrack",
      sellerName: "",
      barcodeValue: "",
      rules: "",
      bookingId: 0,

      logo: "",
      voucherNumber: "",
      providerTitle: "",
      serviceName: "",
      arriveDate: "",
      guestCount: "",
      adultCount: "",
      infantCount: "",
      childCount: "",
      scheduleTime: "",
      firstName: "",
      lastName: "",
      mobileNumber: "",
      nationalCode: "",
      email: "",
      arrivalDate: "",
      reserveNumber: "",
      flightNumber: "",
      isLoading: false,
      addOnOptionList: [],
      customerRequest: "",
      bookingGuests: [],
      inDate: "",
      scheduleDescription: null,
    };
  },

  created() {
    this.providerName = this.$route.params.providerName;
    this.reservedData = this.$store.getters.GetSelectedReserve;

    if (this.providerName.toLowerCase() === "fasttrack") this.providerId = 2;
    else if (this.providerName.toLowerCase() === "dolphin") this.providerId = 1;

    this.getBookDetail();
  },
  methods: {
    async getBookDetail() {
      debugger;
      this.isLoading = true;

      
      this.bookingId = this.$route.params.bookingId;
      const params = {
        bookingId: this.bookingId,
        profileId: localStorage.getItem("SourceProfileId"),
      };
      console.log(params, "params");
      let data = [];
      if (this.providerId === 2) {
        data = await this.$store.dispatch("getBookingDetail", params);
      } else {
        data = await this.$store.dispatch("getBookingDetailDolphin", params);
      }
      console.log(data, "data");
      this.isLoading = false;
      if (data.statusCode === 0) {
        let bookingDetail = data.data[0];
        this.voucherNumber = bookingDetail.voucherNumber;
        this.flightNumber = bookingDetail.description;
        this.reserveNumber = bookingDetail.reserveNumber;
        this.arrivalDate = bookingDetail.arrivalDate;
        this.providerTitle =
          bookingDetail.bookingProductDetails[0].product.provider.name;
        this.sellerName = bookingDetail.source.name;
        this.serviceName = bookingDetail.bookingProductDetails[0].product.name;
        this.addOnOptionList =
          bookingDetail.bookingProductDetails[0].bookingProductDetailAddOnOptions;
        this.guestCount = bookingDetail.pax;
        this.adultCount = bookingDetail.adult;
        this.childCount = bookingDetail.child;
        this.infantCount = bookingDetail.infant;
        this.bookingGuests = bookingDetail.bookingGuests.filter(
          (p) => p.isCustomerReserver === false
        );
        const mainGuest = bookingDetail.bookingGuests.find(
          (p) => p.isCustomerReserver === true
        );
        this.firstName = mainGuest.firstName;
        this.lastName = mainGuest.lastName;
        this.mobileNumber = mainGuest.mobileNumber;
        this.email = mainGuest.emailAddress;
        this.nationalCode = mainGuest.nationalCode;
        this.rules =
          bookingDetail.bookingProductDetails[0].product.termsAndConditions;
        this.scheduleTime =
          bookingDetail.bookingProductDetails[0].schedule.description;
        this.logo =
          bookingDetail.bookingProductDetails[0].product.provider.logo;
        this.customerRequest = bookingDetail.customerRequest;
        this.inDate = bookingDetail.inDate;
        this.scheduleDescription =
          bookingProductDetails[0].schedule.description;
      } else {
        // alert(data.messages[1]);
        this.$toast.error(data.messages[1], {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
    },

    backToSearch() {
      this.$router
        .push({
          path: "/tourism/tourismSearch/" + this.providerName,
        })
        .catch(() => {});
    },
    print() {
      const localOptions = {
        styles: [
          "https://dariushgroup.com/css/bootstrap.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "https://dariushgroup.com/css/printTicket.css",
        ],
      };
      this.$htmlToPaper("voucherdata", localOptions, () => {});
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

caption {
  font-size: 28px;
  margin-bottom: 15px;
}

th {
  background-color: #f0f0f0;
}

h4,
p {
  margin: 0px;
}
</style>